import { render, staticRenderFns } from "./TaskPager.vue?vue&type=template&id=7d7a3b63&scoped=true"
import script from "./TaskPager.vue?vue&type=script&lang=js"
export * from "./TaskPager.vue?vue&type=script&lang=js"
import style0 from "./TaskPager.vue?vue&type=style&index=0&id=7d7a3b63&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d7a3b63",
  null
  
)

export default component.exports